const STUDENT_RESET_CONTEXT_KEY = "studentPasswordResetContext";

const safeStorageGet = (key) => {
  try {
    return localStorage.getItem(key);
  } catch (_error) {
    return null;
  }
};

const safeStorageSet = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error(`Unable to persist ${key}:`, error);
  }
};

const safeStorageRemove = (key) => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error(`Unable to clear ${key}:`, error);
  }
};

const safeParse = (value, fallbackValue) => {
  if (!value) return fallbackValue;

  try {
    return JSON.parse(value);
  } catch (_error) {
    return fallbackValue;
  }
};

export const maskStudentEmail = (email) => {
  const normalizedEmail = String(email || "").trim();
  if (!normalizedEmail.includes("@")) return normalizedEmail;

  const [localPart, domain] = normalizedEmail.split("@");
  const safeLocalPart = localPart.trim();
  const firstCharacter = safeLocalPart[0] || "";
  const lastCharacter =
    safeLocalPart.length > 2 ? safeLocalPart[safeLocalPart.length - 1] : "";
  const maskedLocal =
    safeLocalPart.length <= 2
      ? `${firstCharacter}*`
      : `${firstCharacter}${"*".repeat(
          Math.max(1, safeLocalPart.length - 2)
        )}${lastCharacter}`;

  return `${maskedLocal}@${domain}`;
};

export const normalizeStudentResetContext = (value = {}) => ({
  email: String(value?.email || "").trim().toLowerCase(),
  resetId: String(value?.resetId || value?.id || "").trim(),
  resetToken: String(value?.resetToken || value?.token || "").trim(),
});

export const getStoredStudentResetContext = () =>
  normalizeStudentResetContext(
    safeParse(safeStorageGet(STUDENT_RESET_CONTEXT_KEY), {})
  );

export const persistStudentResetContext = (value = {}) => {
  const nextValue = normalizeStudentResetContext(value);
  safeStorageSet(STUDENT_RESET_CONTEXT_KEY, nextValue);
  return nextValue;
};

export const clearStudentResetContext = () => {
  safeStorageRemove(STUDENT_RESET_CONTEXT_KEY);
};
